import React from "react";
import BreadCrumb from "../../../Common/BreadCrumb";

import logo from "../../../assets/images/logo-icon.svg"
import light from "../../../assets/images/logo-light.svg"
import dark from "../../../assets/images/logo-dark.svg"
import { Link } from "react-router-dom";

const InvoicePage = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Invoice" pageType="Apps" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4">
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Invoice
            </h2>
            <div className="space-y-12">
              <div className="flex flex-wrap justify-between gap-4">
                <div className="flex items-center gap-2">
                  <img
                    src={logo}
                    className="w-12 h-12"
                    alt=""
                  />
                  <div>
                    <h3 className="text-xl font-bold dark:text-white">
                      Sliced Admin
                    </h3>
                    <p className="text-base text-muted dark:text-darkmuted">
                      Hello@mail.com
                    </p>
                  </div>
                </div>
                <div>
                  <p className="text-base max-w-[200px] text-muted dark:text-darkmuted">
                    4379 Sycamore Road Cascade Locks, OR 97014
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap justify-between gap-4 p-5 bg-light/50 dark:bg-dark rounded-2xl">
                <div className="">
                  <h3 className="mb-4 text-xl font-semibold dark:text-white">
                    Invoice Number
                  </h3>
                  <div className="dark:text-darkmuted">
                    <p>INV-2023-05</p>
                    <p>11 May 2023</p>
                    <p>INV-2023-05</p>
                  </div>
                </div>
                <div className="max-w-[200px]">
                  <h3 className="mb-4 text-xl font-semibold dark:text-white">
                    Billed To
                  </h3>
                  <div className="dark:text-darkmuted">
                    <p>Irving Armstrong</p>
                    <p>I3760 Norman Street Los Angeles, CA 900635</p>
                  </div>
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold dark:text-white">
                  Item Detail
                </h3>
                <p className="text-muted dark:text-darkmuted">
                  Type item for Hours item
                </p>
              </div>
              <div className="overflow-auto">
                <table className="min-w-[640px] w-full">
                  <thead>
                    <tr className="ltr:text-left rtl:text-right">
                      <th>#</th>
                      <th>Item name</th>
                      <th>Hours</th>
                      <th>rate/hr</th>
                      <th>Tax</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Payment Sliced Admin Design</td>
                      <td>209</td>
                      <td>$40.00</td>
                      <td>$0.00</td>
                      <td>$8,360.00</td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Payment Google Logo Design</td>
                      <td>100</td>
                      <td>$40.00</td>
                      <td>$0.00</td>
                      <td>$4,000.00</td>
                    </tr>
                    <tr className="border-b-0">
                      <td className="border-b-0"></td>
                      <td className="border-b-0"></td>
                      <td className="border-b-0"></td>
                      <td className="border-b-0"></td>
                      <td className="font-bold">Sub Total</td>
                      <td>$12,360.00</td>
                    </tr>
                    <tr className="border-b-0">
                      <td className="border-b-0"></td>
                      <td className="border-b-0"></td>
                      <td className="border-b-0"></td>
                      <td className="border-b-0"></td>
                      <td className="font-bold">Discount</td>
                      <td>$0.00</td>
                    </tr>
                    <tr className="border-b-0">
                      <td className="border-b-0"></td>
                      <td className="border-b-0"></td>
                      <td className="border-b-0"></td>
                      <td className="border-b-0"></td>
                      <td className="font-bold">Total Tax</td>
                      <td>$0.00</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="font-bold">Total Amount</td>
                      <td className="font-bold">$12,360.00</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div className="shrink-0">
                  <img
                    src={dark}
                    className="dark:hidden"
                    alt=""
                  />
                  <img
                    src={light}
                    className="hidden dark:block"
                    alt=""
                  />
                </div>
                <div className="flex flex-wrap gap-3 text-muted dark:text-darkmuted">
                  <p className="max-w-[200px]">
                    (408) 996–1010 support@gmail.com website.com
                  </p>
                  <p className="max-w-[200px]">
                    One Apple Park Way Cupertino, CA 95014
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-end gap-4">
                <Link
                  to="#"
                  className="transition-all duration-300 rounded-md btn bg-purple/20 text-purple hover:bg-purple hover:text-white"
                >
                  <span>Print</span>
                </Link>
                <Link
                  to="#"
                  className="transition-all duration-300 rounded-md btn bg-danger/20 text-danger hover:bg-danger hover:text-white"
                >
                  <span>Cancel</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default InvoicePage;
